/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76046ResDataItemTaskListItemChildListItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** 任务内容 */
  taskTitle?: string;
  
  /** 任务内容 */
  taskContent?: string;
  
  /** 任务状态 */
  taskStatus?: string;
  
  /** 是否正常 */
  isNormal?: string;
  
  /** 截止时间 */
  endTime?: string;
  
};
    
  
    
export interface IAPI76046ResDataItemTaskListItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** task */
  taskTitle?: string;
  
  /** 任务id */
  endTime?: string;
  
  /** 子任务信息列表 ,TaskInstanceChildInfoResp */
  childList?: IAPI76046ResDataItemTaskListItemChildListItem[];
  
};
    
  
    
export interface IAPI76046ResDataItem {
  
  /**  */
  showTime?: string;
  
  /** 日期字符串 */
  showTimeStr?: string;
  
  /** 子任务信息列表 ,TaskInstanceListByGroupResp */
  taskList?: IAPI76046ResDataItemTaskListItem[];
  
};
    
  



export type API76046Req = {};



export type API76046Res = IAPI76046ResDataItem[];


// 接口函数 76046 任务实例列表按时间

export interface IUseGetAPI76046Return {
  /** 任务实例列表按时间: 接口请求状态 */
  isAPI76046Loading: boolean;
  /** 任务实例列表按时间: 接口请求返回数据 */
  dataAPI76046: API76046Res;
  /**  任务实例列表按时间: 接口数据请求方法 */
  fetchAPI76046Data: ( config?: YWRequestConfig) => Promise<API76046Res>;
  /** 任务实例列表按时间: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76046 = ():IUseGetAPI76046Return => {
  let isMount = true;
  const [isAPI76046Loading, setIsAPI76046Loading] = useState(false);
  const [dataAPI76046, setDataAPI76046] = useState<API76046Res>({} as API76046Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/list/time`;

  const fetchAPI76046Data = async ( config?: YWRequestConfig): Promise<API76046Res> => {
  
    if ( isMount ) {
      setIsAPI76046Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76046Res>(`${basePath}/yoaichat-web/task/instance/list/time`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76046(res || {} as API76046Res);
        setIsAPI76046Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76046Loading(false);
      }
      return false as unknown as API76046Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76046Loading,
    dataAPI76046,
    fetchAPI76046Data,
    requestUrl,
  }
}

